import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { Icon } from '../../../../common/html/icon'
import { PopupDeleteCompany } from '../../../common/popup/PopupDeleteCompany'
import { TYPE_DELETE } from '../../../constant'
import { changeFragment } from '../../portfoliosOverview/store/slice/sliceComponent'
import {
  removeIdInListIdAll,
  selectCheckboxDetail,
  selectDataHeaderPortfolioDetail,
  selectDataSelectedTablePortfolioDetail,
} from '../store/slice'
import { delDeleteCompany, getHeaderSavedPortfolioDetail } from '../store/thunk'

export const CustomTdActionDetail = ({ rowId }) => {
  const dispatch = useDispatch()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const [isShowDelete, setIsShowDelete] = useState(false)

  const dataRow = useSelector(selectDataSelectedTablePortfolioDetail)[rowId]
  const { portfolioName } = useSelector(selectDataHeaderPortfolioDetail)
  const listCheckbox = useSelector(selectCheckboxDetail(['listIdsSelected']))
  const isCanNavigate = !Object.values(listCheckbox).some(Boolean)

  const onSubmitDelete = () => {
    dispatch(
      delDeleteCompany({
        deleteType: TYPE_DELETE.IN,
        portfolioIds: [parseInt(id)],
        organizationIds: [rowId],
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(removeIdInListIdAll([rowId]))
        dispatch(changeFragment())
        dispatch(getHeaderSavedPortfolioDetail({ portfolioId: id }))
      })
      .catch(() => {})
  }

  return (
    <div
      style={{
        pointerEvents: !isCanNavigate ? 'none' : 'auto',
      }}
    >
      <Icon
        className="icon-trash-fill"
        style={{ fontSize: 15, color: '#9C9C9C' }}
        onClick={() => setIsShowDelete(true)}
      />
      {isShowDelete && (
        <PopupDeleteCompany
          isShow={isShowDelete}
          setShow={setIsShowDelete}
          onSubmit={onSubmitDelete}
          renderContent={() => (
            <Translate
              value="library.detailsPortfolios.TEXT_DELETE_SINGLE_COMPANY"
              companyName={dataRow?.organizationName}
              portfolioName={portfolioName}
              dangerousHTML
            />
          )}
        />
      )}
    </div>
  )
}
